import { useEffect, useState } from 'react';
import { PaddlePaymentContext } from './context/PaddlePaymentContext';
import Plans from './components/Plans';
import Payment from './components/Payment';

export const PAGE_PADDLE = {
	PLAN_PAGE: <Plans />,
	PAYMENT_PAGE: <Payment />,
};

const OneOffPaddlePayment = () => {
	const [pickedPlan, setPickedPlan] = useState();
	const [transactionId, setTransactionId] = useState();
	const [page, setPage] = useState(PAGE_PADDLE.PLAN_PAGE);
	const [email, setEmail] = useState();
	const [promo, setPromo] = useState();

	useEffect(() => {
		setTimeout(() => {
			setEmail(() => localStorage.getItem('quiz_email'));
			const promo = localStorage.getItem('promo');

			if (promo) {
				setPromo(() => true);
			}
		}, 100);
	}, []);

	return (
		<>
			<PaddlePaymentContext.Provider
				value={{
					pickedPlan,
					setPickedPlan,
					setPage,
					transactionId,
					setTransactionId,
					email,
					promo,
				}}
			>
				{page}
			</PaddlePaymentContext.Provider>
		</>
	);
};

export default OneOffPaddlePayment;
